import { DatePipe } from '@angular/common';
import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { FiltersComponent, UserRepositoryService, UserGroup, User } from 'reg-hub-common';

@Component({
  selector: 'app-users-filter',
  templateUrl: './users-filter.component.html',
  styleUrl: './users-filter.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class UsersFilterComponent extends FiltersComponent<User> implements OnInit {
  @Input() userGroup!: UserGroup;

  constructor(
    repo: UserRepositoryService,
    formBuilder: FormBuilder,
    datePipe: DatePipe) {
    super(repo, formBuilder, datePipe);
  }
  
  ngOnInit(): void {
    this.repo.populateBaseLink([this.userGroup!.corporationID, this.userGroup!.id]);
    
    this._filterForm = this.formBuilder.group({
      isActive: [true],
      username: [null],
      firstName: [null],
      middleName: [null],
      lastName: [null],
      email: [null]
    });

    this.repo.getFirstPage();
  }
}